export const TEXTS = {
    SHOW: "Show",
    HIDE: "Hide",
};
